export default import.meta.ROLLDOWN_FILE_URL_XjisqtNRVme6srN496NpNg